import { OwnerAuthProvider } from "@/components/owner/OwnerAuthProvider";
import { Stack } from "expo-router";
import React from "react";

export default function OwnerLayout() {
  return (
    <OwnerAuthProvider>
      <Stack screenOptions={{ headerShown: false }} />
    </OwnerAuthProvider>
  );
}
